const en = {
  // Navigation
  nav: {
    home: 'Home',
    about: 'About',
    experience: 'Experience',
    projects: 'Projects',
    contact: 'Contact',
  },

  // Hero Section
  hero: {
    greeting: 'Cybersecurity Specialist',
    titles: ['Cybersecurity Specialist', 'SOC Analyst Tier 1', 'Ethical Hacking Enthusiast'],
    description: 'Security automation, threat monitoring and defense for modern systems.',
    viewProjects: 'View Projects',
    downloadCV: 'Download CV',
  },

  // About Section
  about: {
    title: 'About',
    description: 'My name is Diogo Cunha, I am 24 years old, and I serve in the Portuguese Air Force. I am a cybersecurity specialist with 3+ years in defense operations, focused on monitoring, threat hunting, and security automation. I have strong experience in Python development and network security, building resilient systems and practical tools. I got into this field because of my passion for technology, which led me to pursue cybersecurity. My goal is to learn as much as possible and keep growing both professionally and personally.',
    stats: {
      experience: 'Years Experience',
      certifications: 'Certifications',
      projects: 'Security Projects',
    },
    highlightsTitle: 'What I Bring',
    highlights: {
      securityOps: {
        title: 'Security Operations',
        description: 'Hands-on defense work across monitoring, investigation, and incident response with a risk-based mindset.',
      },
      threatAnalysis: {
        title: 'Threat & Malware Analysis',
        description: 'Triage and analysis to understand behavior, reduce exposure, and improve detection and response playbooks.',
      },
      automation: {
        title: 'Automation & Tooling',
        description: 'Builds practical tooling that streamlines repetitive work and turns security insights into repeatable workflows.',
      },
    },
  },

  // Experience Section
  experience: {
    title: 'Experience',
    subtitle: 'My journey through the cybersecurity and IT industry',
    tabs: {
      professional: 'Professional',
      academic: 'Academic',
      certifications: 'Certifications',
    },
    jobs: {
      cybersecuritySpecialist: {
        title: 'CyberSecurity Specialist',
        company: 'Portuguese Air Force',
        responsibilities: [
          'Malware Analysis and Detection',
          'Vulnerability Assessment',
          'Python automation and scripting',
          'Penetration Testing',
          'Operating systems and network fundamentals',
        ],
      },
      complianceAnalyst: {
        title: 'Compliance Specialist',
        company: 'Leica Microsystems',
        responsibilities: [
          'SAP system management',
          'Excel data analysis',
          'Compliance reporting and documentation',
        ],
      },
      itConsultant: {
        title: 'IT Consultant',
        company: 'Inetum',
        responsibilities: [
          'Client support and consulting',
          'System integration',
        ],
      },
      itTechnician: {
        title: 'IT Technician',
        company: 'Claranet',
        responsibilities: [
          'IT Equipment Installation',
          'Equipment preparation for installation',
          'IP Configuration on Printers',
          'Computer setup and network configuration',
        ],
      },
    },
    education: {
      cybersecurity: {
        degree: 'Cybersecurity',
        institution: 'ISTEC',
        level: 'Level 5 Technician',
        description: 'Advanced studies in cybersecurity, focusing on penetration testing, network defense, and secure system architecture.',
      },
      programming: {
        degree: 'Management and Programming of Computer Systems',
        institution: 'Escola Secundária Leal da Câmara',
        level: 'Level 4 Qualification',
        description: 'Foundation in computer systems, programming, and IT management.',
      },
    },
    certifications: [
      { name: 'Cyber Defender Final Examination', issuer: 'MILE2', year: '2024' },
      { name: 'C)ITP: Certified Information Technology Principles', issuer: 'MILE2', year: '2024' },
      { name: 'C)SP: Certified Security Principles', issuer: 'MILE2', year: '2024' },
      { name: 'C)NP: Certified Network Principles', issuer: 'MILE2', year: '2024' },
      { name: 'ACS-CD-NSD: Network Security and Defense', issuer: 'MILE2', year: '2024' },
      { name: 'ACS-CD-IRM: Incident Response and Management', issuer: 'MILE2', year: '2024' },
      { name: 'ACS-CD-TIVM: Threat Intelligence and Vulnerability Management', issuer: 'MILE2', year: '2024' },
      { name: 'ACS-CD-FOC: Foundations of Cybersecurity', issuer: 'MILE2', year: '2024' },
      { name: 'Ethical Hacking Essentials (EHE)', issuer: 'EC-Council', year: '2022' },
      { name: 'Digital Forensics Essentials (DFE)', issuer: 'EC-Council', year: '2023' },
    ],
  },

  // Projects Section
  projects: {
    title: 'Featured Projects',
    subtitle: 'Selected security tooling, automation, and engineering work.',
    featured: 'Featured',
    items: {
      blueTeam: {
        title: 'Blue Team Defense Scripts',
        description: 'Collection of Python scripts designed for cybersecurity monitoring and defense operations. Automated tools for threat detection, log analysis, and incident response in blue team operations.',
        overlay: 'Blue Team Defense',
      },
      carapauCracker: {
        title: 'CarapauCracker - Security Analysis Tool',
        description: 'Advanced Python-based security analysis and testing framework. Developed for penetration testing and vulnerability assessment with automated shell scripting capabilities.',
        overlay: 'Security Analysis',
      },
      writeUpPage: {
        title: 'Write-Up Page',
        description: 'A dedicated page for organizing and publishing security write-ups, challenges, and technical analysis. Designed to present content in a clear, structured, and easy-to-browse way.',
        overlay: 'Write-Ups',
      },
      sportsAnalysis: {
        title: 'Sports Analysis',
        description: 'A Flashscore-like platform focused on deeper analysis for sports trading — detailed match statistics and outcome probabilities.',
        overlay: 'Sports Analysis',
      },
    },
  },

  // Contact Section
  contact: {
    title: 'Get In Touch',
    subtitle: 'Open to projects, collaborations, and security roles.',
    infoTitle: "Let's Talk!",
    infoText: "Share a brief overview and timeline, and I'll respond as soon as possible.",
    email: 'Email',
    location: 'Location',
    locationValue: 'Lisbon / Portugal',
    form: {
      name: 'Name',
      namePlaceholder: 'Your name',
      email: 'Email',
      emailPlaceholder: 'Your email',
      message: 'Message',
      messagePlaceholder: 'Your message',
      submit: 'Send Message',
      success: 'Message sent successfully! Thank you for reaching out.',
      errors: {
        nameRequired: 'Please enter your name',
        emailRequired: 'Please enter your email',
        emailInvalid: 'Please enter a valid email',
        messageRequired: 'Please enter a message',
      },
    },
  },

  // Footer
  footer: {
    builtWith: 'Built with React | Cybersecurity Portfolio',
    role: 'Cybersecurity Specialist | Full Stack Developer',
  },
};

export default en;
